import React from 'react';
import DocumentIcon from '../../../assets/icons/pdf2.svg';
import DocumentIcons from './Document.Icons';
import LockIcon from '../../../assets/icons/lock.svg';
import { API_URL } from '../settings';
import { getFileUrl } from '../utils';
import ComingSoon from './ComingSoon';
import NotApplicable from './Document.NotApplicable';
import DocumentPopover from './DocumentPopover';
import DocumentMenu from './DocumentMenu';
import { useIsMainSubscribed } from '@src/hooks/user';
import { slugify } from '@src/utils/slugify';
import { trackDocumentClick } from '@src/utils/trackDocumentClick';

const Document = ({ document }) => {
  const isSubscribed = useIsMainSubscribed();
  const displayAsTooltip = document?.tableTooltip;

  if (displayAsTooltip) {
    return <NotApplicable content={document?.name} />;
  }

  if (!document) return <ComingSoon />;

  const { freeDocument, freeSample, hasPassword, module, documentCategory, name } = document;

  const apiFileUrl = `${API_URL}/${getFileUrl(document.fileUrl)}?id=${document.originalId}`;

  // Subscription documents go to embedded viewer when user is subscribed
  const detailsPageUrl =
    document.isSubscription && isSubscribed
      ? `/embeded?id=${document.originalId}`
      : name &&
        `/modules/${module?.slug}/${documentCategory
          ?.map((c) => c.slug)
          .join('/')}/${encodeURIComponent(slugify(name))}`;

  const isFreeDocument = [freeDocument, freeSample, hasPassword && freeDocument].some(Boolean);

  // Show popover menu only if user is NOT subscribed AND document requires subscription
  const shouldShowPopover = !isSubscribed && document.isSubscription;

  if (isFreeDocument) {
    return (
      <div className="document-icon-container">
        <a
          href={apiFileUrl}
          style={{ cursor: 'pointer' }}
          onClick={() =>
            trackDocumentClick(document, {
              source: 'table',
              outcome: 'opened',
              isSubscribed,
              destinationUrl: apiFileUrl,
            })
          }
        >
          <img src={DocumentIcon} className="category-option-image doc-icon" alt="Document" />
          {document.hasPassword && (
            <img src={LockIcon} className="category-option-image lock-icon" alt="Document" />
          )}
        </a>
      </div>
    );
  }

  // If user is subscribed or document doesn't require subscription, show direct clickable link
  if (!shouldShowPopover) {
    return (
      <div className="document-icon-container">
        <a
          href={detailsPageUrl}
          style={{ position: 'relative', cursor: 'pointer', display: 'block' }}
          onClick={() =>
            trackDocumentClick(document, {
              source: 'table',
              outcome: document.isSubscription && isSubscribed ? 'opened' : 'detail',
              isSubscribed,
              destinationUrl: detailsPageUrl,
            })
          }
        >
          <img
            src={DocumentIcon}
            className="category-option-image doc-icon"
            style={{ height: 35 }}
            alt="Document"
          />
          <DocumentIcons requiresSubscription={document.isSubscription} id={document.originalId} />
        </a>
      </div>
    );
  }

  // Otherwise, show popover menu with subscribe/buy options
  return (
    <div className="document-icon-container">
      <DocumentPopover
        trigger={
          <div style={{ position: 'relative', cursor: 'pointer' }}>
            <img
              src={DocumentIcon}
              className="category-option-image doc-icon"
              style={{ height: 35 }}
              alt="Document"
            />
            <DocumentIcons
              requiresSubscription={document.isSubscription}
              id={document.originalId}
            />
          </div>
        }
      >
        {(onClose) => <DocumentMenu document={document} onClose={onClose} />}
      </DocumentPopover>
    </div>
  );
};

export default Document;
